import { useTrans } from "@/translations";

import { type BuildingListRow, BuildingStatus } from "../types";

const CONTAMINATION_HIGH_THRESHOLD = 15;
const CONTAMINATION_MID_THRESHOLD = 8;

const getContaminationStyle = (contamination: number) => {
  if (contamination >= CONTAMINATION_HIGH_THRESHOLD) {
    return "bg-[#FFE0D6] text-[#B73A23]";
  }
  if (contamination >= CONTAMINATION_MID_THRESHOLD) {
    return "bg-[#FDEBD0] text-[#C98A1B]";
  }

  if (contamination > 0) {
    return "bg-[#EDEFD0] text-[#6E6E3E]";
  }

  return "text-grey4";
};

type Props = {
  row: BuildingListRow;
  onSelectRow: (row: BuildingListRow) => void;
};

export const RowView: React.FC<Props> = ({ row, onSelectRow }) => {
  const { t } = useTrans();
  return (
    <tr
      className="border-grey2 hover:bg-grey1 cursor-pointer border-t bg-white"
      onClick={() => onSelectRow(row)}
    >
      <td className="px-[12px] py-[13px] text-[13.5px] font-semibold">
        {row.name}
      </td>
      <td className="px-[12px] py-[13px] text-right text-[13.5px] font-bold">
        {row.rate.toFixed(row.rate % 1 ? 1 : 0)}%
      </td>
      <td className="px-[12px] py-[13px] text-right text-[13px] whitespace-nowrap">
        {row.waste.toLocaleString()} {row.wasteUnit}
      </td>
      <td className="px-[12px] py-[13px] text-right text-[13px]">
        <span
          className={`inline-flex min-w-[24px] items-center justify-center rounded-[6px] px-[7px] py-[2px] text-[12px] font-semibold ${getContaminationStyle(
            row.contamination,
          )}`}
        >
          {row.contamination || "–"}
        </span>
      </td>
      <td className="px-[12px] py-[13px] text-right text-[13px]">
        {row.tenants}
      </td>
      <td className="px-[12px] py-[13px]">
        <span className="inline-flex items-center gap-[7px] text-[13px]">
          <span
            className={`h-2 w-2 flex-none rounded-full ${
              row.status === BuildingStatus.ON_TRACK
                ? "bg-[#3F9142]"
                : "bg-[#C98A1B]"
            }`}
          />
          {t(`portfolioPage:buildingListStatus${row.status}`)}
        </span>
      </td>
    </tr>
  );
};
